import { render } from "./index.vue?vue&type=template&id=cedd7344&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"

import "./index.vue?vue&type=style&index=0&id=cedd7344&lang=css"
import "./index.vue?vue&type=style&index=1&id=cedd7344&scoped=true&lang=css"

import exportComponent from "/usr/src/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-cedd7344"]])

export default __exports__